import React from "react";
import { Link } from "react-scroll";

function ButtonOutlined(props: any) {
  const { text, target } = props;
  return (
    <div>
      <button className="bg-transparent border border-1 rounded-pill  py-2 px-2 poppins-medium text-transform-uppercase font-13 letter-spacing-2 text-white">
        <Link
          to={target}
          spy={true}
          smooth={true}
          offset={-70}
          duration={100}
          className="text-decoration-none text-white"
          style={{ cursor: "pointer" }}
        >
          {text}
        </Link>
      </button>
    </div>
  );
}

export default ButtonOutlined;
